import ButtonActionsOnUser from '../buttonActionsOnUser';
import { AdminUserPermissionsEnum } from '@/lib/enum';
import { SecuredComponent } from '@/components/hoc';
import BannerUserInfos from '../bannerUserInfos';
import { IHasClassName } from '@/interfaces';
import { IHasCertification } from '.';
import { cn } from '@/lib/utils';

type TProps = IHasCertification & IHasClassName & {
	removeItemLocally?: (userId: string) => void;
	disableActionInvalidations?: boolean;
};

const UserCertificationItemUserInfos = ({ certification, className, removeItemLocally, disableActionInvalidations }: TProps) => (
	<div className='flex items-center justify-between cursor-pointer px-4 max-w-[420px] hover:bg-neutral-50'>
		<BannerUserInfos
			hideEmail
			enableClickToRedirectToProfile
			user={certification.userData}
			className={cn('w-full', className)} />
		<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.PROFILE_DETAIL_ACTIONS]}>
			<ButtonActionsOnUser
				hideText
				disableInvalidateQueries={disableActionInvalidations}
				removeItemLocally={removeItemLocally}
				user={certification.userData as any} />
		</SecuredComponent>
	</div>
);

export default UserCertificationItemUserInfos;

